/* global google */
import MarkerWithLabel from '@google/markerwithlabel';

/**
 * Adriatic guide map powered by google maps
 * require: Google Maps JS API URL (endpoint + parameters)
 */

const guideMap = {
    data: {},
    layers: {},
    layerMarkers: {},
    mapOptions: {},
    map: {},
    icon: {},
    // funkcija inicijalizira google mapu i ostale potrebne objekte. Kao argumet prosljediti objekat sa properijima:
    // data - sadrži podatke o kml-ovima, mapPlaceHolder - placeholder mape, blankimageUrl - url do prazne slike,
    // potrebno zbog MarkerWithLabel-a
    init: function (options) {
        this.data = $.parseJSON(options.data);
        this.mapOptions = {
            center: new google.maps.LatLng(44.126042, 15.232315),
            zoom: 7,
            disableDefaultUI: true,
            zoomControl: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        };
        this.map = new google.maps.Map(options.mapPlaceHolder, this.mapOptions);
        this.icon = new google.maps.MarkerImage(options.blankimageUrl, new google.maps.Size(1, 1));
        this.initLayers();
        this.registarClickEvents();
    },

    initLayers: function () {
        const self = this;
        // init kml layers
        $.each(self.data, (index, item) => {
            const type = item.type;
            const layer = new google.maps.KmlLayer(item.file, {
                suppressInfoWindows: true,
                preserveViewport: true,
            });
            self.layers[item.title] = {
                type,
                value: layer,
            };

            google.maps.event.addListener(self.layers[item.title].value, 'click', () => {
                document.location = item.url;
            });
        });

        // add event to layers for creating markers
        $.each(self.layers, function addEventToLayer(index, item) {
            google.maps.event.addListener(item.value, 'defaultviewport_changed', function () {
                // ako postoji inicijaliziran marker
                if (index in self.layerMarkers) {
                    self.layerMarkers[index].marker.setVisible(true);
                } else {
                    // ako nema stvori ga
                    const point = (item.type === 'island')
                        ? new google.maps.Point(80, 10)
                        : new google.maps.Point(40, 20);

                    const marker = new MarkerWithLabel({
                        position: this.getDefaultViewport().getCenter(),
                        draggable: false,
                        icon: self.icon,
                        raiseOnDrag: true,
                        title: index,
                        map: self.map,
                        labelContent: index,
                        labelAnchor: point,
                        labelClass: 'LabeledMarker_markerLabel', // the CSS class for the label
                        labelStyle: { opacity: 1.0 },
                    });

                    self.layerMarkers[index] = {
                        type: item.type,
                        marker,
                    };
                }
                // hide-a ostale markere
                $.each(self.layerMarkers, (idx, val) => {
                    if (item.type != val.type) {
                        val.marker.setVisible(false);
                    }
                });
            });

            // postavlja regije kao početne layere
            if (item.type === 'region') {
                item.value.setMap(self.map);
            }
        });
    },
    registarClickEvents: function clickEvents() {
        const self = this;
        $('#mapcontrol a').click(function clickOnMapControl(event) {
            $('#mapcontrol a').removeClass('selectedTab');
            $(this).addClass('selectedTab');
            const id = $(this).attr('id');
            event.preventDefault();
            // change layers
            $.each(self.layers, (index, item) => {
                (item.type == id ? item.value.setMap(self.map) : item.value.setMap(null));
            });
        });
    },
};

export default guideMap;
